export const craftPurchaseCategoryMixin = {
  data () {
    return {
      icons: {
        1: 'tshirt-crew-outline',
        2: 'sword',
        3: 'necklace',
        4: 'face',
        5: 'hair-dryer',
        6: 'pine-tree',
        7: 'infinity'
      }
    }
  },
  methods: {
    craftPurchaseGetIconName (categoryId) {
      return this.icons[categoryId]
    }
  }
}
